import React from 'react';
import { Theme, IconButton, Hidden, useMediaQuery, useTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import HamburgerMenuIcon from '@material-ui/icons/Menu';
import * as DrawerSize from '../DrawerSize';
import { buildDrawerTransition } from '../buildDrawerTransition';
import clsx from 'clsx';

export const LogoImage = (props: LogoProps): JSX.Element => {
    const { onClick, logo } = props;
    const { narrowSrc, wideSrc, customClasses } = logo;

    const classes = useStyles();
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('sm'));

    const imageWidth = narrowSrc && isTablet ? DrawerSize.narrow : DrawerSize.wide;
    const imageBackground = `url('/${narrowSrc && isTablet ? narrowSrc : wideSrc}')`;

    const containerClass = clsx(classes.logoContainer, customClasses && customClasses.container);

    const imageClass = clsx(classes.logoImage, customClasses && customClasses.image);

    return (
        <React.Fragment>
            <Hidden smUp>
                <IconButton onClick={onClick}>
                    <HamburgerMenuIcon className={classes.white} />
                </IconButton>
            </Hidden>
            <Hidden xsDown>
                <div
                    className={containerClass}
                    style={{
                        width: imageWidth
                    }}
                >
                    <div
                        onClick={onClick}
                        style={{
                            backgroundImage: imageBackground
                        }}
                        className={imageClass}
                    />
                </div>
            </Hidden>
        </React.Fragment>
    );
};

const useStyles = makeStyles((theme: Theme) => {
    const transition = buildDrawerTransition(theme);

    return {
        white: {
            color: theme.palette.common.white
        },
        logoImage: {
            height: '100%',
            width: '100%',
            backgroundRepeat: 'round'
        },
        logoContainer: {
            backgroundColor: theme.palette.common.white,
            padding: theme.spacing(0.5),
            height: 64,
            transition
        }
    };
});

export interface LogoProps {
    logo: {
        narrowSrc?: string;
        wideSrc: string;
        customClasses?: Partial<Record<'image' | 'container', string>>;
    };
    onClick: () => void;
}
